// extracted by mini-css-extract-plugin
module.exports = {"btn":"changepassword_btn__OqHxy","inputContainer":"changepassword_inputContainer__3hrsQ","input":"changepassword_input__2Ii-Y"};